var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg86(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0144043 25.5629V3.33429C0.0144043 1.49281 1.50721 0 3.34869 0H16.6858C18.5273 0 20.0201 1.49281 20.0201 3.33429V25.5629C20.0191 25.9859 19.778 26.3716 19.3983 26.558C19.0185 26.7443 18.5659 26.6989 18.2307 26.4409L11.3843 21.1171C10.5807 20.4904 9.45382 20.4904 8.6502 21.1171L1.8038 26.4409C1.46861 26.6989 1.01599 26.7443 0.636235 26.558C0.256475 26.3716 0.0154192 25.9859 0.0144043 25.5629Z",
    fill: "#00DDC1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg86);
export default __webpack_public_path__ + "static/media/86.605a536883682574ba22e0ded967f772.svg";
export { ForwardRef as ReactComponent };